import {
  EvaluatorReturnType,
  EvaluatorType,
  getReturnTypesForEvaluatorType,
  returnTypeToString,
} from "@/types/app/evaluator";
import { SelectInput, SelectProps } from "@components/molecules/FormikInput";
import { InfoTooltip } from "@components/molecules/InfoTooltip";
import { SelectItem } from "@components/ui/select";

interface Props {
  evaluatorType: EvaluatorType;
  returnType: EvaluatorReturnType;
  setReturnType: (returnType: EvaluatorReturnType) => void;
}

export const ReturnTypeSelect = ({
  evaluatorType,
  returnType,
  setReturnType,
  ...props
}: Props & Partial<SelectProps>) => {
  return (
    <SelectInput
      name="return_type"
      label="Type"
      // infoTooltipContent="The type of judgment that the Evaluator will return"
      value={returnType}
      setValue={(value) => setReturnType(value as EvaluatorReturnType)}
      {...props}
    >
      {getReturnTypesForEvaluatorType(evaluatorType).map((returnType) => (
        <SelectItem key={returnType} value={returnType}>
          {returnTypeToString(returnType)}
        </SelectItem>
      ))}
    </SelectInput>
  );
};
